'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var responseTypes = require('./response-types.js');

var fromString = require('uint8arrays/from-string');

var toString = require('uint8arrays/to-string');

var createGet = configure.configure(function (api) {
  function get(_x) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
      var options,
          res,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          message,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return api.post('dht/get', {
                signal: options.signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                  arg: key instanceof Uint8Array ? toString.toString(key) : key
                }, options)),
                headers: options.headers
              });

            case 3:
              res = _context.sent;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 6;
              _iterator = _asyncIterator(res.ndjson());

            case 8:
              _context.next = 10;
              return _iterator.next();

            case 10:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 17;
                break;
              }

              message = _step.value;

              if (!(message.Type === responseTypes.Value)) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return", fromString.fromString(message.Extra, 'base64pad'));

            case 14:
              _iteratorAbruptCompletion = false;
              _context.next = 8;
              break;

            case 17:
              _context.next = 23;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](6);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 23:
              _context.prev = 23;
              _context.prev = 24;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 28;
                break;
              }

              _context.next = 28;
              return _iterator.return();

            case 28:
              _context.prev = 28;

              if (!_didIteratorError) {
                _context.next = 31;
                break;
              }

              throw _iteratorError;

            case 31:
              return _context.finish(28);

            case 32:
              return _context.finish(23);

            case 33:
              throw new Error('not found');

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 19, 23, 33], [24,, 28, 32]]);
    }));
    return _get.apply(this, arguments);
  }

  return get;
});
exports.createGet = createGet;